"use client";

interface ConfigSectionProps {
  title: string;
  description?: string;
  children: React.ReactNode;
}

export default function ConfigSection({
  title,
  description,
  children,
}: ConfigSectionProps) {
  return (
    <section className="rounded-lg border border-border bg-card/30 overflow-hidden">
      <div className="px-3 py-2 border-b border-border bg-muted/30">
        <h3 className="text-xs font-medium uppercase tracking-wide text-muted-foreground">
          {title}
        </h3>
        {description ? (
          <p className="text-xs text-muted-foreground/80 mt-0.5">{description}</p>
        ) : null}
      </div>
      <div className="px-3 py-1">{children}</div>
    </section>
  );
}
